import { render, staticRenderFns } from "./PromotionalBanner.vue?vue&type=template&id=1933fc15"
import script from "./PromotionalBanner.vue?vue&type=script&lang=js"
export * from "./PromotionalBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports